module.exports = __webpack_public_path__ + "media/images/clients/copy_mgm-f955e84e5acd1969eaa2b4c2f21210ef.svg";